import React, { useEffect, useState, useRef } from "react";
import { useAppDispatch } from "../../../../../store";
import { useSelector } from "react-redux";
import * as styles from "../../../../../styles/WholedataPage";
import styled from "styled-components/macro";

const DownCon = styled.div`
  position: absolute;
  width: 100%;
  bottom: 40px;
  right: 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DowunTxt = styled.div`
  padding: 10px;
  background-color: #73972c;
  border-radius: 10px;
  margin: 10px 0px;
  color: white;
  cursor: pointer;
`;

const ImageModal = ({ modal, setModal, modalImage }: any) => {
  const Downfunc = () => {
    const link = document.createElement("a");
    link.href = modalImage;
    link.download = "modalImage.jpg";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <styles.ImageModal className={modal === 2 ? "modal-open" : "modal-close"}>
      <div
        className="modal"
        onClick={() => {
          setModal(0);
        }}
      >
        <div className="imagebox">
          <img style={{ width: "90%" }} src={modalImage} />
        </div>
      </div>

      <DownCon>
        <DowunTxt onClick={Downfunc}>다운로드</DowunTxt>
      </DownCon>
    </styles.ImageModal>
  );
};
export default ImageModal;
